import {AnyAction} from "redux";
import {TOGGLE_DEBUG_CONSOLE} from "../../actions/action";

//  selectors

export const getDebugConsoleVisible = state => state.debugConsole.visible;

//  define initial state

const initialState: boolean = false;

/**
 * reducer: handle debug console visibility
 * @param state
 * @param action
 * @return {boolean}
 */
export function visible(state: boolean = initialState, action: AnyAction) : any
{
    switch (action.type)
    {
        case TOGGLE_DEBUG_CONSOLE:
        {
            const {payload} = action;
            const {visible} = payload;

            return visible;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/debug-console/visible.ts